module.exports = __webpack_public_path__ + "static/media/pen-edit-blue.f299db95.svg";